<template>
    <div>
        <treeselect
            :multiple="true"
            :options="optionsProcessed"
            :default-expand-level="Infinity"
            @select="selectDeselect"
            @deselect="selectDeselect"
            @input="input"
            :placeholder="placeholder"
            :clearable="false"
            v-model="selectedData"
        />
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            selectedData: [],
            selectedDataPrevious: [],
            optionsProcessed: [],
            groupedValues: {},
            selectDeselectCalled: false
        }
    },
    methods: {
        input() {
            if (this.selectDeselectCalled) {
                if (this.singleroot && _.size(this.selectedData) > 1) {
                    var baseGroup = _.findKey(this.groupedValues, (elms, group) => {
                        if (this.selectedData[0] == group || _.includes(elms, this.selectedData[0])) {
                            return true;
                        }
                    });
                    var lastEl = _.last(this.selectedData);
                    var latestGroup = _.findKey(this.groupedValues, (elms, group) => {
                        if (lastEl == group || _.includes(elms, lastEl)) {
                            return true;
                        }
                    });
                    if (latestGroup != baseGroup) {
                        this.selectedData = _.takeRight(this.selectedData);
                        return;
                    }
                }
                this.selectedDataPrevious = this.selectedData;
                this.$emit('change', this.selectedData);
                this.selectDeselectCalled = false;
            }
        },
        selectDeselect(a, b) {
            this.selectDeselectCalled = true;
        },
        setDataFromParent() {
            if (_.size(this.options) > 0) {
                this.selectedData = _.compact(_.concat([], this.value));
            }
        }
    },
    props: ['options', 'value', 'required', 'singleroot', 'placeholder'],
    watch: {
        value: function (d) {
            this.setDataFromParent();
        },
        options: function () {

            var grouped = {};
            var arr = [];
            var pushIds = function (e) {
                _.each(e, function (ee) {
                    arr.push(_.toString(ee.id));
                    if (ee.children) {
                        pushIds(ee.children);
                    }
                });
            };
            _.each(this.options, function (e) {
                arr = [];
                if (e.children) {
                    pushIds(e.children);
                }
                grouped[_.toString(e.id)] = arr;
            });
            this.groupedValues = grouped;


            // Visu opciju identifikatoriem jābūt kā stringiem
            // (nevaram būt droši par GET parametriem)
            this.optionsProcessed = _.cloneDeepWith(this.options, function (val, key) {
                if (key == 'id') {
                    return _.toString(val);
                }
            });

        }
    }
}
</script>
